<div class="dx-card" id="accordion">
  <dx-accordion
    #accordion
    [dataSource]="[{ title: 'General Information', item: {} }]"
    [collapsible]="true"
    [animationDuration]="300"
    [focusStateEnabled]="false"
    [hoverStateEnabled]="false"
    [selectedIndex]="-1"
    (onSelectionChanged)="onAccordionClick($event)"
  >
    <div *dxTemplate="let itemData of 'title'">
      <h3>
        <span style="padding-left: 0.3em">{{ itemData.title }}</span>
      </h3>
    </div>
    <div *dxTemplate="let itemData of 'item'">
      <dx-form class="bindery-form" labelMode="floating">
        <dxi-item
          itemType="group"
          [colCount]="12"
          [colCountByScreen]="{ xs: 1 }"
        >
          <dxi-item name="date" [colSpan]="12">
            <div *dxTemplate="let data">
              <dx-text-box
                name="date"
                stylingMode="none"
                [value]="date"
                [readOnly]="true"
                [class]="'readonly-date'"
              ></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="publisher" name="publisher" [colSpan]="12">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                [label]="
                  formatMessage('calculator.calculation.us.publisher') + ' *'
                "
                [dataSource]="publishers"
                displayExpr="displayName"
                [searchEnabled]="false"
                style="caret-color: transparent"
                [(value)]="selectedPublisher"
              ></dx-select-box>
            </div>
          </dxi-item>
          <dxi-item name="customerContact" [colSpan]="12">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                label="Customer Contact"
                [(value)]="selectedCustomerContact"
              ></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item name="bpgContact" [colSpan]="12">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                label="BPG Contact"
                [(value)]="selectedBpgContact"
              ></dx-text-box>
            </div>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  </dx-accordion>
</div>
